// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OnFT","textarea":"styles_textarea__eKOQd"};